"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import loadHelper from "./loads";
import Api from "../api/api";
import "../api/account";
import ruleFormatter from "../formatters/rules";
import { splitReferences } from "../helpers/references";
import { escapeRegExp } from "../util/strings";
const renderTemplate = (templateString, templateVariables, user, loadState, invoices, carrier) => {
  const scope = {
    user,
    loadState,
    invoices,
    carrier,
    invoice: invoices[0],
    load: loadState && loadState.load
  };
  const expansionMap = expansions(scope);
  templateString = _.foldl(
    templateVariables,
    (template, variable) => {
      if (!!expand(expansionMap, variable, scope)) {
        template = template.replace(
          new RegExp(`{#if ${variable}}(.*?){#endif}`, "g"),
          "$1"
        );
      } else {
        template = template.replace(
          new RegExp(`{#if ${variable}}.*?{#endif}`, "g"),
          ""
        );
      }
      return replaceVariable(template, variable);
    },
    templateString
  );
  templateString = _.foldl(
    Object.keys(expansionMap),
    replaceVariable,
    templateString
  );
  return templateString;
  function replaceVariable(template, variable) {
    const escapedVariable = escapeRegExp(variable);
    return template.replace(
      new RegExp(escapedVariable, "g"),
      expand(expansionMap, variable, scope)
    );
  }
};
const expand = (expansionMap, variable, scope) => {
  const expansion = expansionMap[variable];
  if (expansion) {
    return expansion(scope);
  } else {
    console.log(`unhandled variable ${variable}`);
    return "";
  }
};
function expansions(scope) {
  if (Api.Account.hasRole("Factor")) {
    return factorExpansions;
  } else {
    return __spreadValues(__spreadValues({}, brokerExpansions), buildReferenceExpansions(scope.load, (x) => `<${x}>`));
  }
}
const factorExpansions = {};
const brokerExpansions = {};
factorExpansions["{carrier_name}"] = ({ carrier }) => {
  if (carrier) {
    return carrier.name;
  }
};
brokerExpansions["{carrier_name}"] = ({ carrier }) => {
  if (carrier) {
    return carrier.name;
  }
};
factorExpansions["{invoice_number}"] = ({ invoice }) => invoice.source_invoice_number;
brokerExpansions["{invoice_number}"] = ({ loadState }) => loadState.invoice_number;
factorExpansions["{load_id}"] = ({ invoice }) => invoice.load_id;
brokerExpansions["{load_id}"] = ({ loadState }) => {
  if (loadState && loadState.load) {
    return loadState.load.load_id;
  } else {
    return "";
  }
};
factorExpansions["{exception_summary}"] = ({ invoice }) => {
  return loadHelper.exceptionSummary(invoice);
};
brokerExpansions["{exception_summary}"] = ({ invoice }) => {
  return loadHelper.exceptionSummary(invoice);
};
factorExpansions["{exception_messages}"] = ({ invoice }) => {
  const rules = loadHelper.enabledRules(invoice);
  const publicRules = _.reject(rules, _.property("internal_failure"));
  const ruleMessages = _.map(publicRules, function(rule) {
    return "    " + ruleFormatter.ruleAsPlainText(rule);
  });
  const exceptionMessages = _.map(
    invoice.exception_events,
    (e) => `    ${e.message_override}`
  );
  return exceptionMessages.concat(ruleMessages).join("\n");
};
brokerExpansions["{exception_messages}"] = ({ loadState, invoice }) => {
  const prePependText = "    ";
  const messages = _.map(loadHelper.allExceptionMessages(invoice, loadState, false, prePependText, true), (message) => {
    return message;
  });
  return messages.join("\n");
};
factorExpansions["{signature}"] = ({ user }) => {
  if (!_.str.isBlank(user.settings.exceptions_signature)) {
    return user.settings.exceptions_signature;
  } else {
    return "";
  }
};
brokerExpansions["{signature}"] = ({ user }) => {
  if (!_.str.isBlank(user.settings.exceptions_signature)) {
    return user.settings.exceptions_signature;
  } else {
    return `

Thanks,

${user.name}`;
  }
};
const accountName = ({ user }) => user.account.name;
factorExpansions["{account_name}"] = accountName;
brokerExpansions["{account_name}"] = accountName;
const addExpansionForReferenceVariable = (variableName, referenceName, referenceSourceFn) => {
  brokerExpansions[variableName] = (scope) => {
    const source = referenceSourceFn(scope);
    if (source) {
      return source.references[referenceName];
    } else {
      return "";
    }
  };
};
addExpansionForReferenceVariable("{order_ids}", "Order IDs", ({ load }) => load);
addExpansionForReferenceVariable("{order_id}", "Order ID", ({ load }) => load);
function buildReferenceExpansions(referenceSource, variableFormatter) {
  const dynamicExpansions = {};
  const references = referenceSource && referenceSource.references || {};
  Object.entries(references).forEach(([referenceName, referenceValue]) => {
    dynamicExpansions[variableFormatter(referenceName)] = (_2) => {
      return splitReferences(referenceValue).join(", ");
    };
  });
  return dynamicExpansions;
}
export { renderTemplate };
